import css from 'styled-jsx/css';

const styles = css.global`.rotoql-popover .popover{border:0;max-width:fit-content}.rotoql-popover__body{border-radius:4px;box-shadow:0 0 25px 0 rgba(0,0,0,.17);background-color:#fff;padding:30px}.rotoql-popover .arrow::before{border:0}`;

export default styles;